import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of } from 'rxjs';
import { Chequebookrequest, ChequebookrequestMaintanence } from './chequebookrequest.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class ChequebookrequestService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Chequebookrequest): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/chequebookrequest');
      let bodyContent = {"chequebookrequest":payload};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.accountsPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
 
  findByKey(key: Chequebookrequest): FindByKeyFn<Chequebookrequest> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/chequebookrequest/{inventoryNumber}');
       httpRequest.addPathParameter('inventoryNumber', key.inventoryNumber);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.chequebookrequest ?? null), map((res:any) => {
          return res ? {...res,  noOfChqBooks:res.noOfChqBooks.code, accountNumber:res.accountNumber, noOfLeaves:res.noOfLeaves.code, dlvryBranch: res.dlvryBranch.branchCode } : null
        }));
        
    };
  }

  modify(payload: Chequebookrequest): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/chequebookrequest/{inventoryNumber}');
       httpRequest.addPathParameter('inventoryNumber', payload.inventoryNumber);
     httpRequest.setMethod('PUT');
      let bodyContent = {"chequebookrequest":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
  
  
 findAll(criteriaQuery: CriteriaQuery): FindAllFn<Chequebookrequest[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/chequebookrequest');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<ChequebookrequestMaintanence>) =>
              res.body.chequebookrequest
          )
        );
    };
  }
  
   
     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/chequebookrequest');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);
 
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
}
